import { useEffect, useMemo, memo, useState, useRef } from "react";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import cn from "classnames";
import { useHistory, useRouteMatch } from "react-router-dom";

import { useLocale } from "src/providers/LocaleProvider";
import theme from "src/theme";
import useStores from "src/hooks/useStores";
import useChangeTheme from "src/hooks/useChangeTheme";
import coinIcon from "src/assets/icons/coin.svg";
import { GameModeType, GameModeTypeNew } from "src/store/models";
import { infoService } from "src/service/services";
import { usePlayer } from "src/sounds/use-player";
import { IPrize } from "src/pages/tournaments/components/bracketContainerNew/types";

import { useStyles } from "./styles";
import FlyingStar from "../../../../components/controls/app-bar/components/animateStar/JackpotStarAnimation";

interface IWinnerAnimation {
    actionWithWinnerWindow: (status: string) => void;
    messageLength?: number;
    tourPrize: {
        title: string;
        prize: IPrize
    }
};

const FlyingStarComponent = ({ isVisible, coordinates, onComplete }) => {
    if (!isVisible) return null;

    return (
        <FlyingStar
            start={coordinates.start}
            end={coordinates.end}
            onComplete={onComplete}
        />
    );
};

const WinnerAnimation = ({
    messageLength,
    actionWithWinnerWindow,
    tourPrize
}: IWinnerAnimation) => {
    const appearanceTheme = useChangeTheme();
    const player = usePlayer();
    const {
        tournaments: {
            titles: {
                prizesTab: { rankPointShort },
            },
            finishPosition,
            finishAlert,
        },
    } = useLocale();

    const { tournamentsStore, gameStore, authStore } = useStores();
    const width = window.innerWidth;
    const isTablet = theme.breakpoints.values.lg;
    // const tournamentWinnerAlert = tournamentsStore?.tournamentWinnerAlert;
    // const myPosition =
    //     typeof tournamentsStore?.tournamentWinnerAlert?.position === "number"
    //         ? tournamentsStore?.tournamentWinnerAlert?.position
    //         : tournamentsStore?.tournamentWinnerAlert?.position[1];
    // const tournamentWinnerAlert = gameStore.currentGameNew?.winner;
    // const myPosition =
    //     tournamentWinnerAlert &&
    //     authStore.currentUser?._id === tournamentWinnerAlert
    //         ? 1
    //         : 2;

    const match = useRouteMatch<{ id?: string }>({
        path: "/game/:id",
    });
    const currentGameId = match?.params?.id || undefined;

    const myPosition = tourPrize.prize.place
    const tournamentId = tourPrize.prize.tournamentId
    const tournamentWinnerAlert = true;

    const currentTournament = useMemo(() => {
        return tournamentsStore?.tournaments?.find(t => t._id === tourPrize.prize.tournamentId);
    }, [tournamentsStore, tourPrize.prize.tournamentId]);

    const buyIn = currentTournament?.buyIn ?? 0;

    const [isFlying, setIsFlying] = useState(() => tourPrize.prize.place === 1 && buyIn !== 0);
    const [showModal, setShowModal] = useState(false);

    const [coordinates, setCoordinates] = useState({
        start: { x: window.innerWidth / 2, y: 0 },
        end: { x: window.innerWidth / 2, y: window.innerHeight / 2 }
    });

    useEffect(() => {
        try {
            const jackpotElement = document.querySelector('.jackpotIconWrapper') ||
                document.querySelector('.jackpotIcon');
            const avatarElement = document.querySelector('.player-avatar') ||
                document.querySelector('[data-avatar="player"]');

            if (jackpotElement && avatarElement) {
                const jackpotRect = jackpotElement.getBoundingClientRect();
                const avatarRect = avatarElement.getBoundingClientRect();

                setCoordinates({
                    start: {
                        x: jackpotRect.left + jackpotRect.width / 2,
                        y: jackpotRect.top + jackpotRect.height / 2
                    },
                    end: {
                        x: avatarRect.left + avatarRect.width / 2,
                        y: avatarRect.top + avatarRect.height / 2
                    }
                });
            }
        } catch (error) {
            console.error("Error calculating coordinates:", error);
        }
    }, []);

    useEffect(() => {
        if (isFlying) return;

        const timer = setTimeout(() => {
            setShowModal(true);
        }, 1000);

        return () => clearTimeout(timer);
    }, [isFlying]);


    const generateAlert = (place: number) => {

        if (document.location.href.indexOf('/game/') < 0) {
            return [];
        }

        if (place === 1) {
            return width >= isTablet
                ? finishPosition[place - 1].long("You are Winner!")
                : finishPosition[place - 1].short("Winner");
        }
        if (place === 2) {
            return width >= isTablet
                ? finishPosition[place - 1].long("You are Second")
                : finishPosition[place - 1].short("Second");
        }
        if (place > 2) {
            return width >= isTablet
                ? finishPosition[place - 1].long("Awardee")
                : finishPosition[place - 1].short("Awardee");
        }
        return [];
    };

    const messageArrayGenerator = (position: number | undefined | null) => {
        if (typeof position === "number") {
            const alert = generateAlert(position);
            if (alert.toLowerCase) {
                return alert.toLowerCase().slice(0, messageLength).split("");
            }
        }
        return [];
    };


    const messageArray = useMemo(
        () => messageArrayGenerator(myPosition),
        [myPosition, messageLength]
    );

    const myLength = messageArray.length;

    // eslint-disable-next-line prettier/prettier
    const classes = useStyles({
        myLength,
        place: myPosition,
    });


    const generateSideAnim = (messages) => {
        const practicleAray: any[] = [];
        const numberOfSplashes = 12;
        messages.forEach((letter, index: number) => {
            const newArray = new Array(numberOfSplashes).fill(index);
            newArray && practicleAray.push(newArray);
        });

        return practicleAray;
    };

    // Always generate saidAnimMatrix regardless of conditions
    const saidAnimMatrix = useMemo(
        () => generateSideAnim(messageArray || []),
        [messageArray]
    );

    //if (!tournamentWinnerAlert || !messageArray) return null;

    return (
        <>

            {/* Анимация летящей звезды перед появлением модалки */}
            <FlyingStarComponent
                isVisible={isFlying && myPosition === 1 && buyIn !== 0}
                coordinates={coordinates}
                onComplete={() => setIsFlying(false)}
            />

            {showModal && messageArray && tournamentWinnerAlert && (
                <>
                    <Dialog
                        open={!!tournamentWinnerAlert}
                        className={classes.dialog}
                        PaperProps={{
                            className: cn(
                                classes.dialogPaperWinnerTour,
                                appearanceTheme,
                                `place${myPosition}`
                            ),
                        }}
                    >
                        <Box className={cn(classes.crossWrapper)}>
                            <div
                                onClick={() => actionWithWinnerWindow(tournamentId)}
                                className={cn(classes.cross)}
                            ></div>
                        </Box>
                        <Box
                            className={cn(
                                classes.winnerAnimationBox,
                                `place${myPosition}`
                            )}
                        >
                            {messageArray.map((item, index) => {
                                return (
                                    <div
                                        key={`containDiv-${index}`}
                                        className={cn(
                                            classes.containDiv,
                                            `containDiv${index}`
                                        )}
                                    ></div>
                                );
                            })}
                            <div className={cn(classes.conditions)}>
                                <Box
                                    className={cn(
                                        classes.textWrapper,
                                        `place${myPosition}`
                                    )}
                                >
                                    {messageArray.map((letter, index) => {
                                        return (
                                            <div
                                                key={`paragraph-${index}`}
                                                // className={`textWinnerArea text${index}`}
                                                className={cn(
                                                    classes.paragraphTextBlock,
                                                    `paragr${index}`
                                                )}
                                            >
                                                <p
                                                    className={cn(
                                                        classes.winnerLetter,
                                                        `place${myPosition}`
                                                    )}
                                                >
                                                    {letter}
                                                </p>
                                            </div>
                                        );
                                    })}
                                </Box>

                                <Box
                                    className={cn(
                                        classes.coinsWrapper,
                                        `place${myPosition}`
                                    )}
                                >
                                    {messageArray.map((item, index) => {
                                        return (
                                            <div
                                                // className={`frame frame${index}`}
                                                key={`coin-${index}`}
                                                className={cn(
                                                    classes.coinBaseArea,
                                                    `coinAreaItem${index}`
                                                )}
                                            >
                                                <img
                                                    className={cn(
                                                        classes.coinPic
                                                    )}
                                                    src={coinIcon}
                                                />
                                            </div>
                                        );
                                    })}
                                </Box>
                            </div>
                        </Box>
                        <Box
                            className={cn(
                                classes.winnerTroffyBox,
                                `place${myPosition}`
                            )}
                        >
                            <p
                                className={cn(
                                    classes.winnerTroffyText,
                                    `place${myPosition}`,
                                    "dollar"
                                )}
                            >
                                {
                                    tourPrize.prize.amount ?
                                        <>
                                            <span style={{ fontWeight: 400 }}>+</span>
                                            {tourPrize.prize.amount.toFixed(0) || 0} Coin
                                        </>
                                        : null
                                }
                            </p>
                            <p
                                className={cn(
                                    classes.winnerTroffyText,
                                    `place${myPosition}`,
                                    "rankPoints"
                                )}
                            >
                                {
                                    tourPrize.prize.rating ?
                                        <>
                                            <span style={{ fontWeight: 400 }}>+</span>{" "}
                                            {tourPrize.prize.rating.toFixed(0) || 0} {rankPointShort("RP")}
                                        </>
                                        : null
                                }
                            </p>
                        </Box>
                        <Box
                            className={cn(
                                classes.winnerTournamentBox,
                                `place${myPosition}`
                            )}
                        >
                            <Box
                                className={cn(
                                    classes.winnerTournamentSubBox,
                                    `place${myPosition}`
                                )}
                            >
                                <p
                                    className={cn(
                                        classes.winnerTroffyText,
                                        `place${myPosition}`,
                                        "tournamentTitle"
                                    )}
                                >
                                    {/* {tournamentWinnerAlert?.title
                                            ? tournamentWinnerAlert?.title
                                            : "Tournament"} */}
                                    {tourPrize.title
                                        ? tourPrize.title
                                        : "Tournament"}

                                </p>
                                <Box
                                    className={cn(
                                        classes.winnerTournamentBoxShine,
                                        `place${myPosition}`
                                    )}
                                ></Box>
                            </Box>
                        </Box>
                    </Dialog>
                </>
            )}
        </>
    );
};

export default memo(WinnerAnimation);
